module.exports = __webpack_public_path__ + "img/icon-startup-white-old.16ba9660.svg";